var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OPEN",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(0.5 0.5)",
    fill: "#feffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "left",
    d: "M6.7,10.979-.628,3.468,1.994,0,6.7,4.83,11.4,0,14.3,3.468Z",
    transform: "translate(6.5 8.5)",
    fill: "#fd9543"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.1c74dcd2cc6af5049c061e123d8e1bcf.svg";
export { ForwardRef as ReactComponent };